// L'état de l'application : UN objet, créé ici, jamais réassigné (qcm.js et lca.js en gardent une référence).
// window.state reste l'alias vivant du même objet tant que du code historique le lit là.
window.state = {
    isAuthenticated: false,
    planningIndisponible: null, // motif quand le planning n'a pas pu être lu : tout enregistrement est alors bloqué
    isLoading: true,
    serverStatus: 'connecting',
    authEmail: '',
    authPassword: '',
    authError: '',
    activeTab: 'dashboard',
    showAutoPlanModal: false,
    // Qui est connecté : rôle (admin / user), droit aux fonctions IA, abonnement — rendu par l'action « me »
    user: { role: 'user', email: '', admin: false, ia: false, abonnement: null },
    configStartDate: '2026-06-23',
    itemsPerDay: 5,
    maxJLimit: 60,
    isLoopMode: false,
    sortStrategy: 'score',
    appendMode: false,
    doublePediatrie: false,
    useSubPartsInAutoPlan: true,
    blocDepuisJ: 0,          // sous-parties : à partir de ce J (14, 21, 30, 45, 60), l'item est revu en un seul bloc ; 0 = jamais
    chargeTotaleParJour: 0,  // ordonnanceur : plafond de séances par jour, J0 ET révisions comptés ; 0 = pas de plafond
    plafondJ0ParJour: 0,     // ordonnanceur : plafond de J0 par jour (sous-parties et renforcements comptés) ; 0 = pas de plafond
    plafondRevisionsParJour: 0, // ordonnanceur : plafond de révisions (J>0) par jour ; 0 = pas de plafond
    planningBesoins: '',     // ordonnanceur : besoins écrits pour l'IA (« Laisser l'IA régler »)
    deuxiemeLot: false,      // ordonnanceur : un deuxième planning posé en même temps, avec ses matières et sa date
    selectedSpecs2: [],
    orderedSpecialties2: [], // ordre de priorité des matières du deuxième planning (même mécanique que le premier)
    configStartDate2: '',
    planningIA: null,        // dernière réponse de l'IA : { explication, avertissements }
    pasJ0: 1,                // ordonnanceur : les J0 avancent d'un jour (1) ou d'un jour sur deux (2, pour tenir deux plannings sur des jours pairs / impairs)
    spacingMode: 'score',    // ordonnanceur : règle des J « selon le score » ou « commun » (la même liste pour tous)
    spacingCommun: '1, 3, 7, 14, 21, 30, 45, 60', // la liste commune, quand spacingMode = 'commun'
    selectedSpecs: [],
    orderedSpecialties: [],
    tasks: [],
    subParts: {},
    gestion: { etat: null, chargement: false, busy: '', progres: null, erreur: null, message: null,
               onglet: 'documents', voixBrouillon: { nom: '', genre: '', langues: 'fr', fichier: '', audio: '', octets: 0 },
               comptes: null, comptesCharges: false, compteOuvert: null, compteDetail: {}, lienReset: null },
    podcasts: {}, podcastsConfigured: null, podcastSpeed: 1, podcastPos: {}, podcastVoices: { A: '', B: '' }, podcastExplicatif: false, collegeStatus: {}, podcastBatch: null, podcastBatchLast: null, taskTimers: {},
    subPartSections: {}, // découpage IA : nom de partie → sections du plan de la fiche qu'elle regroupe
    lca: null,           // onglet LCA : sous-onglet ouvert, filtre, documents de cours (lca.js)
    subPartsArchive: {}, // découpages regroupés (item de moins de X mots) : le découpage d'origine, gardé pour le rétablir
    regroupSeuilMots: 3000, // regroupement : en dessous de ce nombre de mots de fiche, l'item est revu en un seul bloc
    doublePediatrie2: false, // ordonnanceur : renforcement pédiatrie pour le deuxième lot
    splitProposals: {},  // découpage IA : propositions mémorisées par item (les plus récentes d'abord)
    podcastDevis: null, podcastDevisBusy: false, // devis de la synthèse vocale
    calJours: 7,         // calendrier : nombre de jours à venir affichés (une carte ≈ 6 Ko de HTML : une semaine suffit pour rester fluide, le reste vient sur demande)
    calPasses: false,    // calendrier : montrer aussi les jours déjà passés
    lissagePaliers: null, // lissage : paliers « N par jour jusqu'au … » (mémorisés dans les préférences serveur)
    splitLots: {},       // items dont le découpage vient d'un LOT (item → date d'application) : eux seuls sont visés par « Annuler les découpages en lot »
    exams: [],
    examDraft: { name: '', date: '', specs: [] },
    plannings: [],
    currentPlanningId: 'default',
    selectedAutoPlanPresetId: null,
    searchQuery: '',
    filterScore: 'all',
    modalConfig: null,
    draggedSpec: null,
    selectedTaskIds: [],
    lots: { list: [], listeChargee: false, open: null, detail: null, busy: false, error: '', onglet: 'split', choix: {}, parts: 0, nb: 15, explicatif: false, seuilCartes: null, progress: null, devis: null, console: false, diag: null } // traitement par lots (Batches)
};

export const state = window.state;

// Modification en place + redessin différé de la région (rAF). Les sous-états (state.qcm, state.lca…)
// gardent leur forme ; on ne remplace jamais l'objet.
export function setState(patch, opts) {
    Object.assign(state, patch);
    if (!(opts && opts.silencieux)) invalider((opts && opts.region) || 'main');
}
const abonnes = new Set();
export function subscribe(fn) { abonnes.add(fn); return function() { abonnes.delete(fn); }; }
// Une seule image par salve de changements : plusieurs réponses du serveur qui arrivent ensemble ne font
// redessiner qu'une fois. Tant que le moteur de régions n'existe pas, « main » = renderContent().
export function invalider(region) {
    regionsSales.add(region || 'main');
    if (window.__renduPrevu) return;
    window.__renduPrevu = true;
    requestAnimationFrame(function() {
        window.__renduPrevu = false;
        var r = Array.from(regionsSales); regionsSales.clear();
        abonnes.forEach(function(fn) { try { fn(r); } catch (e) { if (window.signalerErreur) window.signalerErreur(e, 'rendu'); } });
        if (window.renderContent) window.renderContent();
    });
}
const regionsSales = new Set();
// Nom historique, conservé pour le code existant : même sémantique, même dédoublonnage.
window.renderContentBientot = function() { invalider('main'); };
export const renderContentBientot = window.renderContentBientot;

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
